import React, { useContext, useEffect } from 'react'

import { useRemoteStrings } from '@acorns/web-utils'

import residentialAddress from 'assets/icons/address-icon.svg'
import { CTAContainer } from 'components/CTAContainer'
import Layout from 'components/Layout'
import Separator from 'components/Separator'

import { HeroHeader, HeroText } from '../shared-components'
import { ShippingAddressContext } from '../ShippingAddressContext'
import { ShippingSubRoutes } from '../types'
import { useAddressErrorTracking } from './events'
import {
  AddressBody,
  AddressCard,
  AddressContainer,
  AddressHeader,
  StyledButton,
  StyledImg,
} from './styled-components'

export const AddressError = () => {
  const track = useAddressErrorTracking()
  const { getRemoteString } = useRemoteStrings()
  const {
    addresses: { unverified: address },
    show,
  } = useContext(ShippingAddressContext)
  const ctaText = getRemoteString({ key: 'spend.edit_address.validation.failed.cta.primary' })

  const handleEditButton = () => {
    track.ctaTapped(ctaText)
    show(ShippingSubRoutes.Edit)
  }

  useEffect(() => {
    if (!address.street1) {
      show(ShippingSubRoutes.Edit)
    }
  }, [address, show])

  return (
    <Layout header={'heroText.header'} text={'heroText.text'}>
      <StyledImg src={residentialAddress} alt="residential address icon" />
      <HeroHeader>
        {getRemoteString({ key: 'spend.edit_address.validation.failed.header' })}
      </HeroHeader>
      <HeroText>{getRemoteString({ key: 'spend.edit_address.validation.failed.body' })}</HeroText>
      <AddressContainer>
        <AddressCard>
          <AddressHeader>
            {getRemoteString({ key: 'spend.edit_address.validation.failed.address.header' })}
          </AddressHeader>
          {address && (
            <AddressBody>
              {address.street1}
              {address?.street2 && `, ${address.street2}`}
            </AddressBody>
          )}
          <AddressBody>
            {address?.city ? `${address.city}, ` : ''}
            {address?.state} {address?.zipCode}
          </AddressBody>
        </AddressCard>
      </AddressContainer>
      <Separator />
      <CTAContainer>
        <StyledButton onPress={handleEditButton}>{ctaText}</StyledButton>
      </CTAContainer>
    </Layout>
  )
}
